export default __webpack_public_path__ + "static/media/Unity CERT.f572471c.png";